// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const AUSTRALIA = "Austr\u00e1lia";
export const AUSTRIA = "Rak\u00fasko";
export const BULGARIA = "Bulharsko";
export const CHINA = "\u010c\u00edna";
export const CZECH_REPUBLIC = "\u010cesk\u00e1 republika";
export const DENMARK = "D\u00e1nsko";
export const ESTONIA = "Est\u00f3nsko";
export const FRANCE = "Franc\u00fazsko";
export const GERMANY = "Nemecko";
export const HUNGARY = "Ma\u010farsko";
export const ISRAEL = "Izrael";
export const ITALY = "Taliansko";
export const JAPAN = "Japonsko";
export const LITHUANIA = "Litva";
export const NETHERLANDS = "Holandsko";
export const NEW_ZEALAND = "Nov\u00fd Z\u00e9land";
export const NORWAY = "N\u00f3rsko";
export const POLAND = "Po\u013esko";
export const SLOVAKIA = "Slovensko";
export const SPAIN = "\u0160panielsko";
export const SWEDEN = "\u0160v\u00e9dsko";
export const UNITED_KINGDOM = "Ve\u013ek\u00e1 Brit\u00e1nia";
export const UNITED_STATES = "Spojen\u00e9 \u0161t\u00e1ty americk\u00e9";
